<template>
  <div class="combine-pay">
        <!-- notify bar -->
        <div class="notify-bar" v-if="hasNotify">
            <div class="notify-bar-container" @click="popupNotify">
                <icon-notify class="icon-notify"/>
                合并支付优惠
            </div>
        </div>

        <!-- header bar -->
        <div id="select-all">
            <div class="header-wrap" :class="hasNotify&&'with-notify'">
                <button class="_left" @click="handleCheckAll">
                    <circle-checkbox :checked="isAllChecked" class="order-checkbox"/>
                    <div>全选</div>
                </button>
                <button type="button" class="_right" @click="onceMore">再来一单</button>
            </div>
        </div>

        <!-- list container -->
        <div id="order-container-c">
            <mt-loadmore style="min-height: 100%;"
                         :top-method="reload"
                         :bottom-method="getOrders"
                         :bottom-all-loaded="viewData['isEnd']"
                         @top-status-change="handleTopStatusChange"
                         @bottom-status-change="handleBtnStatusChange"
                         ref="loadmore_waiting">
                <div class="order-card-wrap"
                     v-for="(order, index) in waitToPayList"
                     :key="order.id">
                    <div class="_checkbox" @click="handleCheck(order, index)">
                        <circle-checkbox :checked="order['_isChosen']" class="order-checkbox"/>
                    </div>

                    <router-link tag="div" class="_wrap" :to="`/order-detail/${order.id}`">
                        <order-card :view-data="order" :show-act-btn="true" :hide-pay="true"
                                    @orderCardAction="(action) => orderCardAction(action, order['id'],order)"/>
                    </router-link>
                </div>

                <div v-if="!viewData['isLoading'] && !waitToPayList.length" class="_empty"> - 没有未支付的订单 -</div>

                <loading :show="viewData['isLoading']" v-if="!pullUpActive && !pullDownActive"/>

                <div v-show="waitToPayList.length!==0 && viewData['isEnd']" class="_end">
                    <span>到底了</span>
                </div>

                <div slot="bottom" class="mint-loadmore-bottom" v-show="listData.length && pullUpActive">
                    <loading :show="viewData['isLoading'] && !pullDownActive"/>
                </div>
            </mt-loadmore>
        </div>

        <!-- foot bar -->
        <div class="price-bar" style="position: relative;">
            <div class="price-container">
                <div class="price-info" v-show="isCheckingPrice">
                    <loading :no-transition="true" :show="true"/>
                </div>
                <div class="price-info" v-show="!isCheckingPrice">
                    <div class="main-info">
                        应付款：
                        <span class="price-unit">¥</span>
                        <span class="price-number">{{prices.total_price/100}}</span>
                    </div>
                    <div class="sub-info">
                        <template v-if="prices.discount_price">
                            已优惠：
                            <span class="price-unit">¥</span>
                            <span class="price-number">{{prices.discount_price/100}}</span>
                        </template>
                        <template v-else>
                            <span style="color: rgba(116, 116, 116, 1)">无优惠</span>
                        </template>
                    </div>
                </div>
            </div>

            <button class="submit" :class="{'disable': !canSubmit}" @click="submit">合并支付</button>
        </div>

        <!-- 合并支付优惠弹出提示 -->
        <mt-popup v-model="notifyShow"
                  :modalFade="true"
                  :lockScroll="true"
                  :close-on-click-modal="true"
                  popup-transition="popup-fade"
                  :modal="true">
            <div class="notify-box" v-show="notifyType==='discount'">
                <div class="_top">
                    <h3 class="_title">合并支付优惠</h3>
                    <p class="_main">相同快递信息（收件人姓名、电话、收件地址完全相同）的冲印订单合并支付享受如下优惠：</p>
                    <p class="_highlight _sub">满2版享8折，满3版及以上享7折<br>不同快递信息的订单合并支付无优惠</p>
                    <p class="_highlight _sub">顺丰配送和普通快递的订单合并支付无优惠</p>
                </div>

                <div class="foot">
                    <button class="confirm-btn" @click="popupNotify(false)">我知道了</button>
                </div>
            </div>
            <div class="notify-box" v-show="notifyType==='submit'">
                <div class="_top">
                    <p class="_main _confirm">你只选中了1单，确定放弃合并支付优惠吗？</p>
                </div>
                <div class="foot">
                    <button class="cancel-btn" @click="submit('one')">直接支付</button>
                    <button class="confirm-btn" @click="popupNotify(false)">重新选择</button>
                </div>
            </div>
        </mt-popup>
    </div>
</template>

<script>
  import {getPayType} from "@/utils/utils";
  import {Popup, Toast, Loadmore} from 'mint-ui';
//   import {UnionSDK} from '../utils/unionSDK';

  import CircleCheckbox from '../components/CircleCheckbox';
  import OrderCard from "../components/OrderCard";
  import NotifyBar from "../components/NotifyBar";
  import IconNotify from "../components/Icon/IconNotify";
  import Loading from "../components/Loadingb";
  import {mapActions,mapState} from "vuex";
  export default {
    name: 'WaitPay',
    components: {
      Loading, IconNotify, NotifyBar, OrderCard, CircleCheckbox,
      [Popup.name]: Popup,
      [Loadmore.name]: Loadmore,
    },

    props: {
      listData: {
        type: Array,
        default: () => [],
      },
      viewData: {
        type: Object,
        default: () => {},
      },
    },
    
    methods: {
      ...mapActions(["smo","checkOrder","printPay"]),
      reload() {
        this.$parent.getOrders(true).then(() => {
          this.resetCheckList();
          this.$refs['loadmore_waiting'].onTopLoaded();
        })
      },
      orderCardAction (action, id,order) {
        this.$parent.orderCardAction(action, id,order);
      },
      resetCheckList() {
        // 重新加载 或者 手动重置列表的的时候 设置选中的列表为空，否则重新加载后未选择仍有价格显示
        this.$set(this, 'checkedList', []);
      },
      getOrders() {
        this.$parent.getOrders().then(() => {
          this.$refs['loadmore_waiting'].onBottomLoaded();
        })
      },

      handleTopStatusChange(status) { 
        (status === 'loading') && this.$set(this, 'pullDownActive', true);
      },
      handleBtnStatusChange(status) { 
        (status === 'loading') && this.$set(this, 'pullUpActive', true);
      },
      // 弹出提示框
      popupNotify(isNotifyShow = true, type = 'discount') {
        if (isNotifyShow) {
          this.notifyType = type
        } else {
          setTimeout(() => this.notifyType = type, 300)
        }

        this.notifyShow = !!isNotifyShow
      },

      // 单个勾选操作
      handleCheck(order, index) {
        let save_key = 'id';
        let currCheckState = !!order['_isChosen'];
        if (currCheckState) { // remove from list
          let indexInCheckedList = this.checkedList.findIndex(item => item === order[save_key]);

          this.checkedList.splice(indexInCheckedList, 1);
        } else { // add to list
          this.checkedList.push(order[save_key]);
        }

        order['_isChosen'] = !currCheckState;
        this.$set(this.waitToPayList, index, order);
      },

      // 全选操作
      handleCheckAll() {
        let currCheckList = [...this.checkedList]
        let currAllCheckState = this.isAllChecked
        let list = this.waitToPayList.map(item => {
          // 如果当前项目选中状态 === 点击时的全选状态
          if (!!item['_isChosen'] === !!currAllCheckState) {
            // update item check state
            item['_isChosen'] = !currAllCheckState
            // update id`s list of checked items
            let indexInCheckedList = currCheckList.findIndex(id => id === item.id)
            if (indexInCheckedList !== -1) {
              currCheckList.splice(indexInCheckedList, 1)
            } else {
              currCheckList.push(item.id)
            }
          }
          return item
        })

        this.$set(this, 'waitToPayList', list)
        this.$set(this, 'checkedList', currCheckList)
      },


      // 返回指定页面
      onceMore() {
        this.sdk.reLaunchTo("pages/index/index");
        // UnionSDK.onload(sdk => {
        //   const url = (sdk.sdk_name === 'alipay')
        //     ? '/pages/hotSearch/hotSearch'
        //     : '/pages/index/index';
        //   sdk.reLaunch({url})
        // })
      },

      /**
       * 提交选中的订单
       * @param arg
       * @returns {Promise<Vue | *|Promise<undefined|*>>}
       */
      async submit(arg) {
        // 当前没有选中的情况
        if (!this.canSubmit) return;
        // 当前正在提交 或者 正在检查价格的时候
        if (this.isSubmiting || this.isCheckingPrice) return Promise.reject();

        // 设置正在提交状态，显示浮动 loading
        this.isSubmiting = true;
        // this.$root.$emit('toggleIndicator', true);

        // 判断当前选中的
        let currOrderItem, type, isErr=false;
        if (arg === 'one') { // 单独订单支付
          // 设置单独提交的参数
          currOrderItem = this.waitToPayList.find(item => item.id === this.checkedList[0]);
          type = 'single';
        } else if (this.checkedList.length <= 1) { // 单独订单支付前弹出提示框选择
          // 取消设置正在提交状态
          this.isSubmiting = false;
        //   this.$root.$emit('toggleIndicator', false);
          return this.popupNotify(true, 'submit') // 弹出选择框，在选择框的操作中，重新执行提交方法。
        } else { // 合并支付
          try {
            let { data } = await this.smo({order_id_list: `[${this.checkedList.join(',')}]`});
            currOrderItem = data;
            type = 'merge';
          } catch (e) { // 如果请求失败，设置请求失败标示
            isErr = true;
            console.log('merge order err: ', e)
          }
        }

        if (isErr) { // 请求失败后，取消设置正在请求状态，并弹出异常提示。
          this.isSubmiting = false;
        //   return this.$root.$emit('toggleIndicator', false)
        }
        this.isSubmiting = false;
        let paramType = getPayType(this.platformInfo.platform,type);
        this.printPay({orderId:currOrderItem.id, type:paramType}).then(res => {
          console.log(res);
          let payObj = {}
          if(this.platformInfo.platform === 'wechat'){
            payObj = res.data.signed_string
            payObj.orderId = currOrderItem.id;
            payObj.description = "gopay";
            payObj.type = type;
          }
          if(this.platformInfo.platform === 'baidu'){
            payObj = {...res.data.orderInfo};
            payObj.orderId = currOrderItem.id;
            payObj.description = "gopay";
            payObj.type = type;
          }
          this.sdk.gopay('pages/miniApi/miniApi', payObj);
        })
      },

      async checkMergeOrder(list) {
        this.isCheckingPrice = true;
        try{
          let {data:{discount_price,total_price} = {discount_price:0,total_price:0}} = await this.checkOrder({orderIdList:list});
          this.$set(this, 'prices', {
            discount_price: parseInt(discount_price),
            total_price: parseInt(total_price)
          })
          setTimeout(() => {
            this.isCheckingPrice = false
          }, 150)
        }catch (e){
          console.log(e);
          this.isCheckingPrice = false;
        }
      },
    },

    computed: {
      ...mapState(['platformInfo']),
      isAllChecked() {
        if (!this.waitToPayList.length)
          return false;

        return this.waitToPayList.every(item => {
          return !!item['_isChosen']
        })
      },

      canSubmit() {
        return !!this.checkedList.length
      }
    },

    watch: {
      checkedList: {
        deep: true,
        handler(val) {
          this.checkMergeOrder([...val])
        }
      },
      
      listData(val) {
        this.waitToPayList = [...val];
        val.length === 0 && this.resetCheckList();
      },
    },

    data() {
      return {
        waitToPayList: [],
        totalPrice: '',
        notifyShow: false,
        notifyType: 'discount',
        hasNotify: true,
        
        isCheckingPrice: false,
        
        checkedList: [],
        prices: {
          discount_price: 0,
          total_price: 0
        },
        combineListParams: {
          page: 0,
          per_page: 40,
          total_required: true,
          state: 'waiting',
        },
        isSubmiting: false,
        pullDownActive: false,
        pullUpActive: false,
      };
    },
  };
</script>

<style scoped lang="scss">
  .combine-pay {
        height: 100%;
        background-color: #fff;
        position: relative;

        * {
            box-sizing: border-box;
        }

        .notify-bar {
            width: 100%;
            height: 0.38rem;
            position: relative;

            .notify-bar-container {
                width: 100vw;
                height: 0.38rem;
                background-color: rgba(221, 232, 255, 1);
                color: rgba(53, 53, 53, 1);
                display: flex;
                justify-content: flex-start;
                align-items: center;
                font-size: 0.14rem;
            }

            .icon-notify {
                margin: 0 0.08rem 0 0.16rem;
            }
        }

        #select-all {
            width: 100%;
            height: 0.5rem;
            position: relative;

            .header-wrap {
                display: flex;
                height: 0.5rem;
                width: 100vw;
                padding: 0 0.12rem;
                font-size: 0.14rem;
                align-items: stretch;
                justify-content: space-between;
                background: white;
                box-shadow: 0 0.02rem 0.04rem 0 rgba(239, 239, 239, 1);

                &.with-notify {
                    top: 0.38rem;
                }
            }

            ._left {
                display: flex;
                align-items: center;
                justify-content: center;
            }

            ._right {
                color: rgba(68, 85, 228, 1);
            }
        }

        .order-checkbox {
            margin-right: 0.14rem;
        }

        .box2 {
            background: white;
            border-bottom: 1px solid rgba(151, 151, 151, 0.15);
            align-items: center;
        }

        #order-container-c {
            padding-bottom: 0.2rem;
            height: calc(100% - 0.57rem - 0.38rem - 0.5rem);
            overflow: scroll;
            -webkit-overflow-scrolling: touch;

            .order-card-wrap {
                box-sizing: border-box;
                background-color: #fff;
                width: 100%;
                padding: 0.24rem 0.16rem 0.24rem 0.12rem;
                display: flex;
                align-items: stretch;
                justify-content: space-between;

                & + .order-card-wrap {
                    border-top: 1px solid rgba(151, 151, 151, 0.15);
                }

                ._checkbox {
                    display: flex;
                    flex-shrink: 0;
                    align-items: center;
                    height: 0.74rem;
                }

                ._wrap {
                    width: 100%;
                    overflow: hidden;
                }
            }
        }
    }

    .mint-popup {
        background-color: transparent;
    }

    ._empty {
        font-size: 0.14rem;
        color: rgba(54, 54, 54, 0.5);
        text-align: center;
        line-height: 2;
        margin-top: 0.12rem;
    }

    ._end {
        position: relative;
        width: 100%;
        height: 0.4rem;
        display: flex;
        align-items: center;
        justify-content: center;
        color: rgba(54, 54, 54, 0.3);
        font-size: 0.12rem;

        span {
            padding: 0 0.1rem;
        }

        &::before,
        &::after {
            content: '';
            width: 0.2rem;
            height: 1px;
            border-top: 1px solid rgba(54, 54, 54, 0.2);
        }
    }

</style>